import React, { useEffect, useState } from "react";
import axios from "axios";
import api from "../config/backend"; // Your API base URL
import "./css/Products.css"; // Import the CSS below
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Products = () => {
    const [categories, setCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [packages, setPackages] = useState([]);
    const [product_Id, setProduct_Id] = useState();

    // Modal states
    const [showProductModal, setShowProductModal] = useState(false);
    const [showPackageModal, setShowPackageModal] = useState(false);

    // Form states
    const [newProduct, setNewProduct] = useState({
        productname: "",
        productdescription: "",
        Category: "",
    });
    const [newPackage, setNewPackage] = useState({
        productId: "",
        name: "",
        unit_price: "",
        case_price: "",
        mrp_price: "",
    });

    const [message, setMessage] = useState("");
    const token = localStorage.getItem("_crm__token");

    // Fetch categories, products, packages
    useEffect(() => {
        fetchCategories();
        fetchProducts();
        setProduct_Id('');
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        fetchPackages(product_Id);
    }, [product_Id]);

    const fetchCategories = async () => {
        try {
            const res = await axios.post(`${api}/Category/get`, { token });
            if (res.data.success) setCategories(res.data.Categories);
        } catch { }
    };

    const fetchProducts = async () => {
        try {
            const res = await axios.post(`${api}/Product/get-product`, { token });
            if (res.data.success) setProducts(res.data.data);
        } catch { }
    };

    const fetchPackages = async (product_Id) => {
        try {
            const res = await axios.get(`${api}/Product/get-package-product?productId=${product_Id}`);
            if (res.data.success) setPackages(res.data.data);
        } catch { }
    };

    // Form handlers
    const handleProductInput = (e) => {
        setNewProduct({ ...newProduct, [e.target.name]: e.target.value });
    };

    const handlePackageInput = (e) => {
        setNewPackage({ ...newPackage, [e.target.name]: e.target.value });
    };

    // Add Product
    const handleAddProduct = async (e) => {
        e.preventDefault();
        setMessage("");
        try {
            const res = await axios.post(`${api}/Product/create-product`, {
                token,
                ...newProduct,
            });
            if (res.data.success) {
                setShowProductModal(false);
                setNewProduct({ productname: "", productdescription: "", Category: "" });
                fetchProducts();
                setMessage("Product added successfully!");
            } else {
                setMessage(res.data.message || "Failed to add product");
            }
        } catch {
            setMessage("Error adding product");
        }
    };

    // Add Package
    const handleAddPackage = async (e) => {
        e.preventDefault();
        setMessage("");
        try {
            const res = await axios.post(`${api}/Product/create-package`, {
                token,
                ...newPackage,
            });
            if (res.data.status) {
                setShowPackageModal(false);
                setNewPackage({
                    productId: "",
                    name: "",
                    unit_price: "",
                    case_price: "",
                    mrp_price: "",
                });
                fetchPackages();
                setMessage("Package added successfully!");
            } else {
                setMessage(res.data.message || "Failed to add package");
            }
        } catch {
            setMessage("Error adding package");
        }
    };
    console.log("packages", packages);

    return (
        <div className="ppm-container">
            {!product_Id ?
                <>
                    <div className="Category_mainHeader">
                        <h2>Products</h2>
                        <button className="add-category-btn" onClick={() => setShowProductModal(true)}>
                            Add Product
                        </button>
                    </div>
                    <table className="category-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Description</th>
                                <th>Category</th>
                                <th>Packages</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.map((prod) => (
                                <tr key={prod?._id}>
                                    <td>{prod?.productname}</td>
                                    <td>{prod?.productdescription}</td>
                                    <td>
                                        {prod?.Category?.name}
                                    </td>
                                    <td className="icon_sender">
                                        <RemoveRedEyeIcon onClick={() => setProduct_Id(prod?._id)} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
                :
                <>
                    <div className="Category_mainHeader" >
                        <h2 style={{ cursor: "pointer" }} onClick={() => { setProduct_Id("") }}><ArrowBackIcon /> Packages</h2>
                        <button className="add-category-btn" onClick={() => setShowPackageModal(true)}>
                            Add Package
                        </button>
                    </div>
                    <table className="category-table">
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>Name</th>
                                <th>Unit Price</th>
                                <th>Case Price</th>
                                <th>MRP Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {packages.length ? packages.map((pkg) => (
                                <tr key={pkg?._id}>
                                    <td>
                                        {pkg?.productId?.productname}
                                    </td>
                                    <td>{pkg?.name}</td>
                                    <td>{pkg?.unit_price}</td>
                                    <td>{pkg?.case_price}</td>
                                    <td>{pkg?.mrp_price}</td>
                                </tr>
                            )) : <tr>
                                <td colSpan="5" style={{ textAlign: 'center' }}>No data available</td>
                            </tr>}
                        </tbody>
                    </table>
                </>
            }

            {message && <div className="ppm-message">{message}</div>}

            {/* Add Product Modal */}
            {showProductModal && (
                <div className="app-modal-addstage">
                    <div className="app-modal-addstage__card">
                        <div className="app-modal-addstage__cardheader">
                            <h3>Add Product</h3>
                            <button className="modal-close" onClick={() => setShowProductModal(false)}>
                                &times;
                            </button>
                        </div>
                        <form className="app-modal-addstage__cardbody" onSubmit={handleAddProduct}>
                            <div className="app-form__group">
                                <div className="app-form__field">
                                    <label className="app-form__field--label">Product Name</label>
                                    <input
                                        className="app-form__field--input"
                                        type="text"
                                        name="productname"
                                        value={newProduct.productname}
                                        onChange={handleProductInput}
                                        required
                                    />
                                </div>
                                <div className="app-form__field">
                                    <label className="app-form__field--label">Description</label>
                                    <textarea
                                        className="app-form__field--input"
                                        name="productdescription"
                                        value={newProduct.productdescription}
                                        onChange={handleProductInput}
                                        required
                                    />
                                </div>
                                <div className="app-form__field">
                                    <label className="app-form__field--label">Category</label>
                                    <select
                                        className="app-form__field--input"
                                        name="Category"
                                        value={newProduct.Category}
                                        onChange={handleProductInput}
                                        required
                                    >
                                        <option value="">Select Category</option>
                                        {categories.map((cat) => (
                                            <option key={cat._id} value={cat._id}>
                                                {cat.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="app-modal-addstage__cardfooter">
                                <button
                                    type="button"
                                    className="app-btn-text"
                                    onClick={() => setShowProductModal(false)}
                                >
                                    Cancel
                                </button>
                                <button type="submit" className="app-btn-contained app-btn-primary">
                                    Add
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Add Package Modal */}
            {showPackageModal && (
                <div className="app-modal-addstage">
                    <div className="app-modal-addstage__card">
                        <div className="app-modal-addstage__cardheader">
                            <h3>Add Package</h3>
                            <button className="modal-close" onClick={() => setShowPackageModal(false)}>
                                &times;
                            </button>
                        </div>
                        <form className="app-modal-addstage__cardbody" onSubmit={handleAddPackage}>
                            <div className="app-form__group">
                                <div className="app-form__field">
                                    <label className="app-form__field--label">Product</label>
                                    <select
                                        className="app-form__field--input"
                                        name="productId"
                                        value={newPackage.productId}
                                        onChange={handlePackageInput}
                                        required
                                    >
                                        <option value="">Select Product</option>
                                        {products.map((prod) => (
                                            <option key={prod._id} value={prod._id}>
                                                {prod.productname}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="app-form__field">
                                    <label className="app-form__field--label">Package Name</label>
                                    <input
                                        className="app-form__field--input"
                                        type="text"
                                        name="name"
                                        value={newPackage.name}
                                        onChange={handlePackageInput}
                                        required
                                    />
                                </div>
                                <div className="app-form__field">
                                    <label className="app-form__field--label">Unit Price</label>
                                    <input
                                        className="app-form__field--input"
                                        type="number"
                                        name="unit_price"
                                        value={newPackage.unit_price}
                                        onChange={handlePackageInput}
                                        required
                                    />
                                </div>
                                <div className="app-form__field">
                                    <label className="app-form__field--label">Case Price</label>
                                    <input
                                        className="app-form__field--input"
                                        type="number"
                                        name="case_price"
                                        value={newPackage.case_price}
                                        onChange={handlePackageInput}
                                        required
                                    />
                                </div>
                                <div className="app-form__field">
                                    <label className="app-form__field--label">MRP Price</label>
                                    <input
                                        className="app-form__field--input"
                                        type="number"
                                        name="mrp_price"
                                        value={newPackage.mrp_price}
                                        onChange={handlePackageInput}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="app-modal-addstage__cardfooter">
                                <button
                                    type="button"
                                    className="app-btn-text"
                                    onClick={() => setShowPackageModal(false)}
                                >
                                    Cancel
                                </button>
                                <button type="submit" className="app-btn-contained app-btn-primary">
                                    Add
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Products;
